/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AppSchemasArbitratorCriterionInputSource } from './appSchemasArbitratorCriterionInputSource';

export interface AppSchemasArbitratorCriterionInput {
  /**
     * @minLength 1
     * @maxLength 120
     */
  label: string;
  /**
     * @minLength 1
     * @maxLength 2000
     */
  description: string;
  source?: AppSchemasArbitratorCriterionInputSource;
}
